import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCarousel, deleteCarousel } from '../actions/CarouselActions';
import { Pane, Heading, Button } from 'evergreen-ui';

import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { Link } from 'react-router-dom';
import CarouselInfoBlock from '../components/CarouselInfoBlock';

class ViewCarousel extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    
    componentDidMount() {
        this.props.dispatch(getCarousel(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deleteCarousel(this.id));
    }

    render() {
            
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/carousel">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista slide-uri
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge slide-ul"
                            title="Confirmare stergere slide"
                            confirmLabel="Sterg definitiv slide-ul"
                            message="Esti sigur ca vrei sa stergi slide-ul?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Slide
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <CarouselInfoBlock carousel={this.props.carousel}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        carousel: state.carousel.current
    }
}

export default connect(mapStateToProps)(ViewCarousel);